import { render } from "./sticky-add-to-cart.vue?vue&type=template&id=6a5e57a6"
import script from "./sticky-add-to-cart.vue?vue&type=script&lang=js"
export * from "./sticky-add-to-cart.vue?vue&type=script&lang=js"

import "./sticky-add-to-cart.vue?vue&type=style&index=0&id=6a5e57a6&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__